import { HelpdeskLink } from "@/features/helpdesk"

interface ModuleHeaderProps {
  title: string
  subtitle?: string
  right?: React.ReactNode
  /** Links this screen to the article that explains it. Renders nothing when
   * the helpdesk is off. */
  helpArticle?: { categoryId: string; articleId: string }
}

export function ModuleHeader({
  title,
  subtitle,
  right,
  helpArticle,
}: ModuleHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-6">
      <div>
        <h1 className="text-lg font-semibold leading-tight tracking-tight text-white">
          {title}
        </h1>
        {subtitle && (
          <div className="mt-0.5 max-w-[80ch] text-[13.5px] text-grey5">
            {subtitle}
          </div>
        )}
        {helpArticle && (
          <HelpdeskLink
            categoryId={helpArticle.categoryId}
            articleId={helpArticle.articleId}
            className="mt-1.5"
          />
        )}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  )
}
